import store from '@/store';

import { each, get, map, removeDeepByKey, debounce } from 'lodash';
import apolloClient from '@/store/apollo';

// Queries import
import ProductGql from '@/extensions/shop/store/graphql/queries/Product.gql';
import ProductsPaginatedGql from '@/extensions/shop/store/graphql/queries/ProductsPaginated.gql';
import ProductsWithArticlesPaginatedGql from '@/extensions/shop/store/graphql/queries/ProductsWithArticlesPaginated.gql';

import CategoriesGql from '@/extensions/shop/store/graphql/queries/Categories.gql';
import ShoppingCartGql from '@/extensions/shop/store/graphql/queries/ShoppingCart.gql';

import ArticlesGql from '@/extensions/shop/store/graphql/queries/Articles.gql';

// Mutations import
import SaveShoppingCartGql from '@/extensions/shop/store/graphql/mutations/SaveShoppingCart.gql';
import CreatePurchaseGql from '@/extensions/shop/store/graphql/mutations/CreatePurchase.gql';

export default {
    // Queries
    fetchProductsPaginated: (data, withArticles = false) =>
        new Promise((resolve, reject) => {
            let query = ProductsPaginatedGql;
            if (withArticles) query = ProductsWithArticlesPaginatedGql;

            let filters = [];
            each(data.filters, entry => filters.push(entry));
            let cachePolicy = 'cache-first';
            if (process.env.VUE_APP_DISABLE_CACHE) {
                // TODO
                cachePolicy = 'no-cache';
            }
            apolloClient
                .query({
                    query,
                    fetchPolicy: cachePolicy,
                    variables: {
                        currentPage: get(data, 'pageInfo.currentPage', 1),
                        perPage: get(data, 'pageInfo.perPage', 10),
                        order: get(data, 'order', 'publish_start'),
                        direction: get(data, 'direction', 'desc'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CO_ProductsPaginated))
                .catch(err => reject(err));
        }),
    fetchProduct: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ProductGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Product))
                .catch(err => reject(err));
        });
    },
    fetchCategories: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CategoriesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Categories))
                .catch(err => reject(err));
        });
    },

    fetchArticles: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ArticlesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Articles))
                .catch(err => reject(err));
        });
    },
    fetchShoppingCart: articles => {
        return new Promise((resolve, reject) => {
            const cartInput = { cartArticleQtyInput: articles };
            apolloClient
                .query({
                    query: ShoppingCartGql,
                    variables: cartInput
                })
                .then(({ data }) => resolve(data.CO_ShoppingCart))
                .catch(err => reject(err));
        });
    },
    // Mutations
    saveShoppingCart: articles =>
        new Promise((resolve, reject) => {
            // articles = removeDeepByKey(articles, '__typename');
            // articles = map(articles, article => {
            //     return { id: article.id, pivot: { qty: article.pivot.qty } };
            // });
            apolloClient
                .mutate({
                    mutation: SaveShoppingCartGql,
                    variables: {
                        shoppingCart: { articles }
                    }
                })
                .then(({ data }) => resolve(data.CO_SaveShoppingCart))
                .catch(error => reject(error.message));
        }),
    debouncedSaveShoppingCart: debounce(function(articles) {
        return this.saveShoppingCart(articles);
    }, 1000),
    saveShoppingCartLocal: articles => {
        // let items = [];
        // if (articles && articles.length) {
        //     articles.forEach(article => {
        //         items.push({ id: article.id, qty: article.pivot.qty });
        //     });
        // }

        let key = _.get(store.getters['auth/member'], 'id') || 'guest';

        let cart = JSON.parse(localStorage.getItem('cart')) || {};
        cart[key] = articles;
        localStorage.setItem('cart', JSON.stringify(cart));
    },
    getShoppingCartLocal: () => {
        const key = _.get(store.getters['auth/member'], 'id') || 'guest';
        const cart = JSON.parse(localStorage.getItem('cart')) || {};
        return cart[key];
    },
    createPurchase: purchase =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreatePurchaseGql,
                    variables: { purchase }
                })
                .then(({ data }) => resolve(data.CO_CreatePurchase))
                .catch(error => reject(error.message));
        })
};
